import { Typography, Link } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

function ShowOlympiads(props) {
  const {
    currentStudyYear,
    nextStudyYear,
    chatFormOpen,
    showProfile,
    showFiles,
  } = props;
  return (
    <>
      <Typography align="justify" variant="body1" component="p">
        Для участия (регистрации) в Многопрофильной университетской олимпиаде
        ГрГУ имени Янки Купалы {currentStudyYear}/{nextStudyYear}, Вам
        необходимо:
      </Typography>
      <ul>
        {showProfile() ? (
          <li>
            Внести персональные данные в раздел меню{" "}
            <Link component={RouterLink} to="/profile" variant="body2">
              «Профиль»
            </Link>
          </li>
        ) : null}
        {showFiles() ? (
          <li>
            Прикрепить фотографию справки, подтверждающей статус учащегося 11
            класса в текущем учебном году (справка установленной формы выдается
            учреждением образование, в котором обучается абитуриент)
          </li>
        ) : null}
        <li>
          Получить подтверждение регистрации (смс на указанный при регистрации
          номер телефона)
        </li>
        <li>
          Выбрать профильную(ые) олимпиаду(ы), в которой(ых) Вы будете принимать
          участие (перечень профильных олимпиад будет доступен после
          подтверждения регистрации)
        </li>
      </ul>
      <Typography align="justify" variant="body1" component="p">
        По вопросам регистрации и порядка проведения олимпиады необходимо
        обращаться в{" "}
        <Link onClick={chatFormOpen} variant="body2">
          «Чат»
        </Link>
        .
      </Typography>
      <Typography align="justify" variant="body1" component="p">
        Обращаем Ваше внимание, что проверка документов осуществляется в рабочие
        дни с 8.30 до 17.00.
      </Typography>
      <Typography align="justify" variant="body1" component="p" color="error">
        Карта учащегося (ученический билет и т.п.) не является документом,
        подтверждающим статус учащегося 11 класса.
      </Typography>
    </>
  );
}

export default ShowOlympiads;
